var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadTestGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.125 53.5184C33.125 53.5184 32.5 55 31.25 55H28.75C27.5 55 26.875 53.5184 26.875 53.5184C22.7775 51.3824 18.1515 50.2381 13.4091 50.2381H5C3.61929 50.2381 2.5 49.1721 2.5 47.8571V7.38095C2.5 6.06599 3.61929 5 5 5H13.4091C19.4026 5 25.2102 6.8277 30 10.175C37.0649 6.725 42.5952 5 46.5909 5H55C56.3807 5 57.5 6.06599 57.5 7.38095V47.8571C57.5 49.1721 56.3807 50.2381 55 50.2381H46.5909C41.8485 50.2381 37.2225 51.3824 33.125 53.5184ZM27.5 14.3428C23.4792 11.3836 18.5267 9.76203 13.4091 9.76203H7.5V45.4763H13.4091C18.3221 45.4763 23.1291 46.5186 27.5 48.4809V14.3428ZM32.5 14.3428V48.4809C36.8709 46.5186 41.6779 45.4763 46.5909 45.4763H52.5V9.76203H46.5909C41.4733 9.76203 36.5208 11.3836 32.5 14.3428Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadTestGuideIcon);
export default __webpack_public_path__ + "static/media/read-test-guide-icon.a3acb89b5b2accc19c3cf5a95bc236c8.svg";
export { ForwardRef as ReactComponent };